import { React, useState, useEffect } from "react";
import "./PyqCpsExamContentComponent.scss";

import { useSelector } from "react-redux";
import Previous_question_paper from "./previous_question_paper/Previous_question_paper";
import Customized_practise_sheet from "./customized_practice_sheet/Customized_practise_sheet";
import User_Exercise_Test from "../../../user_exercise_test/user_exercise_test";
import User_ots_component from "../../../user_exercise_test/user_ots_test_series/ots_tests/OtsTestComponent";
import images from "../../../../../utilities/images/images";
import ExamCracker from "../../../user_exercise_test/user_exam_cracker/exam_cracker";
import Mock_test from "../../../user_exercise_test/user_mock_test/mock_test";
import BitSat from "../../../user_exercise_test/user_bit_sat/bit_sat";
import { connect } from "react-redux";
import uiActions from "../../../../../redux/ui/action";
import AdaptiveCps from "../../../user_exercise_test/user_adaptive_cps/AdaptiveCps";
import CommonBannerComponent from "./CommonBannerComponent";
import AdaptiveCpsCreatePaper from "../../../user_exercise_test/user_adaptive_cps/components/home-components/adaptive-cps-create/AdaptiveCpsCreatePaper";
import HomeWork from "../../../user_exercise_test/user_homework/HomeWork";
import PreviousQuestionPaper from "./previous_question_paper/PreviousQuestionPaper";
import Cuet from "../../../cuet/Cuet";

const PyqCpsExamComponent = (props) => {
  let { history, location } = props;

  const { pathname } = props.location;
  const tab = pathname;

  const [stateComponent, setStateComponent] = useState({ step: 1 });

  const currentCuetPracticeData = useSelector(
    (state) => state?.CuetSlice?.currentCuetPracticeData
  );

  const handleStep = (newStep) => {
    setStateComponent((prevState) => ({
      ...prevState,
      step: newStep,
    }));
  };
  return (
    <>
      <div className="pyqCpsExam_wrapper">
        <div className="pyqCpsExam_InrWrapper">
          {tab === "/create-adaptive-cps" && stateComponent.step === 1 && (
            <AdaptiveCpsCreatePaper handleStep={handleStep} />
          )}
          <div>
            <div className="pyqCPsExam_contentWpr">
              <div className="pyqCpsExamTabBox">
                <div className="heading">
                  {tab == "/pyq" && "Previous Year Questions Paper"}
                  {tab == "/cps" && "Conceptual Problem Sheet"}
                  {tab == "/exam" && "Exams"}
                  {tab == "/ots" && "Test Series"}
                  {tab == "/exam_cracker" && "Exam Cracker"}
                  {tab == "/bit_sat" && "BITSAT"}
                  {tab == "/mock_test" && "Mock tests"}
                  {tab == "/create-adaptive-cps" && "Your Adaptive CPS"}
                  {tab == "/cuet+board" && currentCuetPracticeData?.name}
                </div>

                <div className="pyqCpsExamTabContent">
                  <div className="tab-content" id="myTabContent">
                    {tab === "/pyq" && (
                      <div
                        className={
                          tab === "/pyq"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                        }
                        id="previous"
                        role="tabpanel"
                        aria-labelledby="previous-tab"
                      >
                        <PreviousQuestionPaper />
                      </div>
                    )}

                    {tab === "/cps" && (
                      <div
                        className={
                          tab === "/cps"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                        }
                        id="cstmPractise"
                        role="tabpanel"
                        aria-labelledby="cstmPractise-tab"
                      >
                        <CommonBannerComponent tab={tab} />
                        <Customized_practise_sheet />
                      </div>
                    )}

                    {tab === "/exam" && (
                      <div
                        className={
                          tab === "/exam"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                        }
                        id="exam"
                        role="tabpanel"
                        aria-labelledby="exam-tab"
                      >
                        <User_Exercise_Test history={history} />
                      </div>
                    )}

                    {tab === "/ots" && (
                      <div
                        className={
                          tab === "/ots"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                        }
                        id="ots"
                        role="tabpanel"
                        aria-labelledby="ots-tab"
                      >
                        <User_ots_component history={history} />
                      </div>
                    )}

                    {tab === "/exam_cracker" && (
                      <div
                        className={
                          tab === "/exam_cracker"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                        }
                        id="exam_cracker"
                        role="tabpanel"
                        aria-labelledby="exam_cracker-tab"
                      >
                        <ExamCracker />
                      </div>
                    )}

                    {tab === "/bit_sat" && (
                      <div
                        className={
                          tab === "/bit_sat"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                        }
                        id="bit_sat"
                        role="tabpanel"
                        aria-labelledby="bit_sat-tab"
                      >
                        <BitSat />
                      </div>
                    )}

                    {tab === "/mock_test" && (
                      <div
                        className={
                          tab === "/mock_test"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                        }
                        id="mock_test"
                        role="tabpanel"
                        aria-labelledby="mock_test-tab"
                      >
                        <Mock_test />
                      </div>
                    )}

                    {tab === "/create-adaptive-cps" && (
                      <div
                        className={
                          tab === "/create-adaptive-cps"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                        }
                        id="adaptive_cps"
                        role="tabpanel"
                        aria-labelledby="adaptive_cps-tab"
                      >
                        <AdaptiveCps
                          handleStep={handleStep}
                          step={stateComponent.step}
                          handleButtonClick={2}
                        />
                      </div>
                    )}

                    {tab === "/homework" && (
                      <div
                        className={
                          tab === "/homework"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                        }
                        id="homework"
                        role="tabpanel"
                        aria-labelledby="adaptive_cps-tab"
                      >
                        <HomeWork />
                      </div>
                    )}

                    {tab === "/cuet+board" && (
                      <div
                        class={
                          tab == "/cuet+board"
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                        }
                        id="cuet+board"
                        role="tabpanel"
                        aria-labelledby="cuet+board"
                      >
                        {<Cuet />}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
  };
};

export default connect(null, mapDispatchToProps)(PyqCpsExamComponent);
